import React from 'react';

import { Skeleton } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Permissions } from 'src/app_deprecated/constants/PermissionsConstants';

import { Heading } from 'src/app/components/lib/heading';
import TabPage from 'src/app/layout/main/tab-page';
import { useGetMarketingCampaignQuery } from 'src/app/queries/marketing/get-campaign';
import { usePermissionCheck } from 'src/app/state/user-permissions';

import AutomatedCampaignPerformanceOverview from '../../campaigns/detail/automated-campaign/automated-campaign-performance';
import { RecipientList } from '../../campaigns/detail/shared/recipient-list';

import { WorkflowCampaignContent } from './content';

import type { SavedMarketingCampaign } from 'src/app/queries/marketing/get-campaigns';

export function WorkflowCampaignDetails() {
  const { marketingCampaignId } = useParams();

  const navigate = useNavigate();
  const canViewCampaigns = usePermissionCheck(
    [
      Permissions.AccessEmailMarketing,
      Permissions.ViewCampaigns,
      Permissions.CreateEditCampaigns,
      Permissions.SendCampaigns,
    ],
    'or'
  );

  const { data: campaignDetails, isLoading: campaignDetailsIsLoading } = useGetMarketingCampaignQuery({
    marketingCampaignId: parseInt(marketingCampaignId ?? '', 10),
  });

  const tabs = [
    {
      label: 'Overview',
      to: 'overview',
      hasPermission: canViewCampaigns,
      element: (
        <AutomatedCampaignPerformanceOverview
          campaignDetailsData={campaignDetails as SavedMarketingCampaign}
          loading={campaignDetailsIsLoading}
        />
      ),
      hasNestedRoutes: false,
    },
    {
      label: 'Content',
      to: 'content',
      hasPermission: canViewCampaigns,
      element: <WorkflowCampaignContent marketingCampaignId={Number(marketingCampaignId)} />,
      hasNestedRoutes: false,
    },
    {
      label: 'Recipients',
      to: 'recipients',
      hasPermission: canViewCampaigns,
      element: <RecipientList marketingCampaignId={marketingCampaignId ?? ''} />,
      hasNestedRoutes: false,
    },
  ];

  const handleBackAction = () => {
    navigate('/marketing/workflows');
  };

  return (
    <TabPage
      header={
        <Heading onBackAction={handleBackAction}>
          {campaignDetails?.CampaignName ?? (
            <TitleLoader>
              <Skeleton animation='wave' width='100%' />
            </TitleLoader>
          )}
        </Heading>
      }
      tabs={tabs}
    />
  );
}

const TitleLoader = styled.div`
  width: 250px;
`;
